import {Typography, styled} from '@mui/material';

const StyledSubtitle = styled(Typography)`
	color: ${({theme}) => theme.palette.text.primary};
	font-size: 18px;
	line-height: 28px;

	${({theme}) => theme.breakpoints.down('sm')} {
		font-size: 16px;
		font-weight: 600;
		line-height: 24px;
	}
`;

const StyledDescription = styled(Typography)`
	max-width: 272px;
	color: ${({theme}) => theme.palette.text.secondary};
	font-size: 16px;
	line-height: 24px;

	${({theme}) => theme.breakpoints.down('sm')} {
		font-size: 14px;
		line-height: 20px;
	}
`;

const StyledAttentionDescription = styled(StyledDescription)`
	${({theme}) => theme.breakpoints.down('sm')} {
		flex: 1;
		max-width: none;
		color: #333;
		font-size: 14px;
		line-height: 20px;
	}
`;

export {StyledAttentionDescription, StyledDescription, StyledSubtitle};
